import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';
import { Pipe } from 'types/common';

const useMrvQuery = (seasonId?: string) => {
  const query = useQuery<AxiosResponse<Pipe[]>>({
    queryKey: ['mrv-season', seasonId],
    queryFn: () => API.get('/mrvresources/season/' + seasonId),
    enabled: !!seasonId,
  });

  return query;
};

export default useMrvQuery;
